export const BillingStateVariants = Object.freeze({
    Success: 'success',
    Canceled: 'canceled'
});

export type BillingStateVariant = (typeof BillingStateVariants)[keyof typeof BillingStateVariants];
